export const jobSalaryPeriodsSk = {
  jobSalaryPeriods: {
    'hour': 'Hodina',
    'day': 'Deň',
    'week': 'Týždeň',
    'month': 'Mesiac',
    'year': 'Rok'
  }
};
